import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { equipmentActions } from '../_actions';
import { Title, PageHeader, LoadingCard } from '../Shared';
import arrowLeft from '../Locations/arrowleft.png';
import arrowRight from '../Locations/arrowright.png';
import ReactPlayer from 'react-player';

function Obstacles(props) {
  const { getEquipment, loading, allEquipment } = props;
  const [equipmentId, setEquipmentId] = useState(null);
  const [currentEquipment, setCurrentEquipment] = useState(null);

  useEffect(() => {
    getEquipment();
  }, [getEquipment]);

  useEffect(() => {
    if (equipmentId === null && allEquipment) {
      setEquipmentId(allEquipment[0].id);
      setCurrentEquipment(
        allEquipment.find((e) => e.id === allEquipment[0].id),
      );
    }
  }, [allEquipment, equipmentId]);

  const equipmentIndex = () => ({
    index: allEquipment.findIndex((e) => e.id === equipmentId),
    arrLen: allEquipment.length - 1,
  });

  const next = () => {
    const res = equipmentIndex();
    let next;
    if (res.index === res.arrLen) {
      next = allEquipment[0];
    } else {
      next = allEquipment[res.index + 1];
    }
    setEquipmentId(next.id);
    setCurrentEquipment(allEquipment.find((e) => e.id === next.id));
  };

  const prev = () => {
    const res = equipmentIndex();
    let prev;
    if (res.index === 0) {
      prev = allEquipment[res.arrLen];
    } else {
      prev = allEquipment[res.index - 1];
    }
    setEquipmentId(prev.id);
    setCurrentEquipment(allEquipment.find((e) => e.id === prev.id));
  };

  return (
    <Fragment>
      <Title text="Obstacles &amp; Instructions" />
      <PageHeader className="default">
        <h2 className="text-center orange-title">Tips and Rules</h2>
      </PageHeader>
      {loading && <LoadingCard />}
      {!isEmpty(allEquipment) && currentEquipment && (
        <Container className="mt-2 pr-4 pl-4">
          <div style={{ backgroundColor: '#fff', borderRadius: 30 }}>
            <Row className="mt-2 pl-4 pr-4 text-center">
              <Col className="pt-4 pb-1">
                {currentEquipment && currentEquipment.videoUrl && (
                  <div className="player-wrapper">
                    <ReactPlayer
                      className="react-player"
                      url={currentEquipment.videoUrl}
                      width="100%"
                      height="100%"
                    />
                  </div>
                )}
                {currentEquipment.imageUrl && !currentEquipment.videoUrl && (
                  <img
                    alt="view of obstacle"
                    style={{ borderRadius: 30 }}
                    className="img-fluid text-center"
                    src={currentEquipment.imageUrl}
                  />
                )}
                <p
                  className="orange-title text-center pt-3"
                  style={{ fontSize: '1.1rem' }}
                >
                  {currentEquipment.name}
                </p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: currentEquipment.instructions,
                  }}
                />
              </Col>
            </Row>
            <Row
              className="text-center pb-4"
              style={{ flexDirection: 'space-between' }}
            >
              <Col className="text-right">
                <img
                  style={{ width: 40 }}
                  src={arrowLeft}
                  alt="previous"
                  onClick={() => prev()}
                />
              </Col>
              <Col className="text-left">
                <img
                  style={{ width: 40 }}
                  src={arrowRight}
                  alt="next"
                  onClick={() => next()}
                />
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </Fragment>
  );
}

const mapDispatch = {
  getEquipment: equipmentActions.getAll,
};

function mapState(state) {
  const { allEquipment, loading } = state.equipment;
  return { allEquipment, loading };
}
const connectedObstacles = connect(mapState, mapDispatch)(Obstacles);
export { connectedObstacles as Obstacles };
